import { useCurrentUser } from '@/react/hooks/useUser';

/** for now, we only allow pure admins to manage policies */
export function useCanManagePolicies() {
  const { isPureAdmin: canManagePolicy } = useCurrentUser();
  return canManagePolicy;
}
